import { matchPath } from "react-router";

const setPageTitle = (location) => {
  let path = location.pathname;
  let title = "No-code agentic workflow builder";

  let match = checkPathWithIds(path);
  if (match) path = match.pathnameBase;

  switch (path) {
    case "/":
      title = "Home";
      break;
    case "/project":
      title = "Workflow Library";
      break;
    case "/credential_store":
      title = "Credential Store";
      break;
    case "/custom_functions":
      title = "Custom Functions";
      break;
    case "/forms":
      title = "Forms";
      break;
    case "/mcp":
      title = "MCP";
      break;
    case "/mcp_servers":
      title = "MCP Servers";
      break;
    case "/task":
      title = "Tasks";
      break;
    case "/agents/chats":
      title = "Agent Chats";
      break;
    case "/user_management":
      title = "Humans";
      break;
    case "/artifacts":
      title = "Artifacts";
      break;
    case "/databases":
      title = "Databases";
      break;
    case "/profile":
      title = "Profile";
      break;
    case "/organization":
      title = "Organization Settings";
      break;
    case "/project/file_library":
      title = "File Library";
      break;
    case "/project/logs":
      title = "Workflow Session Runs";
      break;
    case "/project/version_history":
      title = "Workflow Version History";
      break;
    case "/project/logs/progress_view":
      title = "Progress View";
      break;
    case "/project/folder":
      title = "Workflow Library";
      break;
    default:
      break;
  }

  document.title = `${title} | Workflow86`;
};

const checkPathWithIds = (path) => {
  if (matchPath("/project/file_library/*", path))
    return matchPath("/project/file_library/*", path);
  else if (matchPath("/project/logs/progress_view/*", path))
    return matchPath("/project/logs/progress_view/*", path);
  else if (matchPath("/project/logs/*", path))
    return matchPath("/project/logs/*", path);
  else if (matchPath("/project/version_history/*", path))
    return matchPath("/project/version_history/*", path);
  else if (matchPath("/project/folder/*", path))
    return matchPath("/project/folder/*", path);
  else if (matchPath("/custom_functions/*", path))
    return matchPath("/custom_functions/*", path);
  else if (matchPath("/forms/*", path)) return matchPath("/forms/*", path);
  else if (matchPath("/artifacts/*", path))
    return matchPath("/artifacts/*", path);
};

export default setPageTitle;
